import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=6149cf4d&scoped=true&"
import script from "./AboutHeader.vue?vue&type=script&lang=js&"
export * from "./AboutHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutHeader.vue?vue&type=style&index=0&id=6149cf4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149cf4d",
  null
  
)

export default component.exports